<template>
    <!-- 容器五 -->
    <container-five>
        <!-- 右边内容 -->
        <slot> 这里输入内容 </slot>
    </container-five>
</template>
<script>
    export default {
         
    }
</script>
<style scoped lang="less">
   .container-five{
       height:100%;
       background: red;
       padding-top:0 !important;
   }
</style>




// WEBPACK FOOTER //
// src/components/BaseCpts/containerFive.vue